import React, { memo } from "react";

import * as Typed from "./Price.typed";
import styles from "./Price.module.css";

import { roundTwoDigits } from "../utils/roundTwoDigits";

const Price = memo<Typed.Props>(({ costPerLiter }) => {
  return (
    <>
      <div className={styles["info-block"]}>
        <div className={styles["info-item-description-price"]}>
          Цена колеровки за литр:
        </div>
        <div className={styles["price"]}>
          {costPerLiter && roundTwoDigits(costPerLiter)} ₽
        </div>
      </div>
    </>
  );
});

export { Price, Typed as PriceTyped };
